export const DEFAULT_LANGUAGE = 'en';

export const languageAliases: Record<string, string> = {
  'en-gb': 'en',
  'en-au': 'en',
  'en-ca': 'en',
  'en-nz': 'en',
  'en-za': 'en',
  'pt-br': 'pt',
  'pt-pt': 'pt',
  'es-ar': 'es',
  'es-cl': 'es',
  'es-co': 'es',
  'es-mx': 'es',
  'fr-ca': 'fr',
  'zh-cn': 'zh',
  'zh-tw': 'zh'
};
